import { z } from 'zod';

export const FleetAssistantRepliedPayloadSchema = z.object({ messageId: z.uuid() });
export type FleetAssistantRepliedPayload = z.infer<typeof FleetAssistantRepliedPayloadSchema>;
